import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { EnvironmentService } from '@services/environment.service';
import { datadogRum } from '@datadog/browser-rum';

const environmentService = new EnvironmentService();

if (environmentService.DATA_DOG_TOKEN) {
  datadogRum.init({
    applicationId: '4b9c8968-8444-4ebd-9d1b-1f00531e9bf5',
    clientToken: environmentService.DATA_DOG_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'lmn-swa-pro-web-accounting',
    version: environmentService.DATA_DOG_VERSION,
    env: environmentService.DATA_DOG_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [
      /http:\/\/localhost:.*/,
      /http:\/\/.*\.golmn\.com/,
      /https:\/\/.*\.golmn\.com/,
      /https:\/\/.*groundsguyspro\.com/,
    ],
    excludedActivityUrls: [
      /clientstream\.launchdarkly\.com/,
      /events\.launchdarkly\.com/,
      /www\.facebook\.com/,
      /px\.ads\.linkedin\.com/,
      /clarity\.ms/,
      /data\.pendo\.io/,
    ],
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
